const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20still%20from%20a%20romantic%20Chinese%20drama%2C%20warm%20golden%20hour%20lighting%2C%20emotional%20atmosphere%2C%20soft%20cinematic%20composition%2C%20elegant%20characters%20in%20modern%20setting%2C%20clean%20background&width=800&height=450&seq=media-01-laozi&orientation=landscape',
    title: '玫瑰的故事 · 精彩片段',
    duration: '03:25',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20scene%20still%20from%20an%20ancient%20Chinese%20detective%20drama%2C%20dark%20moody%20lighting%2C%20Tang%20dynasty%20setting%2C%20tense%20atmosphere%2C%20dramatic%20composition%2C%20traditional%20architecture&width=800&height=450&seq=media-02-laozi&orientation=landscape',
    title: '唐朝诡事录 · 高能片段',
    duration: '04:12',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20fantasy%20scene%20still%20from%20a%20Chinese%20mythological%20drama%2C%20ethereal%20magical%20lighting%2C%20dreamy%20atmosphere%2C%20floating%20elements%2C%20ancient%20costumes%2C%20soft%20glowing%20particles&width=800&height=450&seq=media-03-laozi&orientation=landscape',
    title: '长相思 · 名场面回顾',
    duration: '05:08',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20scene%20still%20from%20a%20Korean%20legal%20drama%2C%20modern%20office%20setting%2C%20professional%20atmosphere%2C%20dramatic%20contrast%20lighting%2C%20clean%20composition%2C%20Seoul%20city%20background&width=800&height=450&seq=media-04-laozi&orientation=landscape',
    title: '好搭档 · 高光时刻',
    duration: '02:58',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          精彩片花
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          热门剧集精彩片段速览
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer">
              <div className="relative w-full aspect-video overflow-hidden rounded-t-xl">
                <img
                  src={item.image}
                  alt={`${item.title} - 精彩片花`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-200 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-white transition-all duration-200 group-hover:scale-110">
                    <i className="ri-play-fill text-xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 bg-black/70 text-white text-xs px-2 py-1 rounded-md font-medium">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors duration-150">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}